module.exports = __webpack_public_path__ + "img/footer-logo-1.26fd5792.png";